import { Box, Container, Divider, Grid, Stack, styled, Tooltip, Typography, useMediaQuery } from "@mui/material";
import LogoPTT from "../../assets/Image/logo-ptt.png";
import Footer3 from "../../assets/Image/ImgFooter/Footer3.png";
import TopFooter from "../../assets/Image/ImgFooter/TopFooter.png";
import BgFooter from "../../assets/Image/ImgFooter/Footer.jpg";
import { useEffect, useState } from "react";
import { AxiosGet } from "service/CommonFunction/TS_function";
import { Link, NavLink } from "react-router-dom";
import AOS from "aos";
import { currentLanguage } from "service/CommonFunction/AxiosConfig";
import { AiFillAndroid } from "react-icons/ai";

const ContainerBG = styled("div")(
    {
        // backgroundImage: `url(${bgMain1})`,
        // background: 'radial-gradient(ellipse at center, rgba(79, 79, 79, 1) 0%, rgba(34, 34, 34, 1) 100%)',
        backgroundImage: `url(${BgFooter})`,
        // backgroundImage: `linear-gradient(0deg, rgba(7,35,63,0.8687850140056023) 0%, rgba(255,255,255,0.28335084033613445) 100%), url(${TopFooter})`,
        // background: `radial-gradient(410px 50px at 50% 0,transparent, 80%, #000 80.5%) center,radial-gradient(410px 50px at 50% 50px,#000, 80%, transparent 80.5%)center,linear-gradient(#000,#000) content-box, url(${bgMain1})`,
        backgroundPositionX: "center",
        backgroundPosittionY: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        color: '#000000',
        position: 'relative',
        paddingTop: '3em',
        boxShadow: '-2px -3px 14px -6px #888888',
        textAlign: 'center'
        // backgroundAttachment: "fixed"
    }
);

function SiteMap() {
    return (
        <>
            <Grid container direction="row" justifyContent="start" alignItems="center" style={{ backgroundImage: `url(${TopFooter})`, padding: '16px', width: '100%', objectFit: 'cover' }}>
                <Grid item xs={12} sm={4} md={1.5}>
                    <div
                        style={{
                            backgroundColor: 'transparent',
                            color: '#242377',
                            borderRadius: '30px',
                            textAlign: 'center',
                            padding: '8px',
                            // boxShadow: 'rgb(0 0 0 / 42%) 0px 2px 3px 0px',
                            fontWeight: 500,
                            fontSize: '1.3em'
                        }}
                    >
                        SITEMAP
                    </div>
                </Grid>
            </Grid>
        </>
    );
}

function Copyright() {
    const LayoutMin650 = useMediaQuery('(min-width:650px)');
    // const Layout500 = useMediaQuery('(min-width:500px)');

    return (
        <>
            <Grid container justifyContent={'center'} style={{ backgroundImage: `url(${Footer3})`, width: '100%', height: '50px', color: '#ffffff', padding: LayoutMin650 ? '16px' : '6px' }}>
                <Grid item xs={12} sm={'auto'} style={{ textAlign: LayoutMin650 ? 'right' : 'center' }}>
                    Copyright &copy; 2022 PTT Public Company Limited
                </Grid>
                {LayoutMin650 ? <Divider orientation="vertical" flexItem style={{ border: '1px solid #ffffff', margin: '0px 16px', background: '#ffffff' }} /> : null}
                <Grid item xs={12} sm={'auto'}>
                    <a href="https://pttpdpa.pttplc.com/Privacy/154159" target="_blank" rel="noreferrer" style={{ color: '#ffffff' }}>
                        {'Privacy & Cookie Policy i Terms of Service'}
                    </a>
                </Grid>
            </Grid>
        </>
    );
}

const LayoutFooter = (props) => {

    const { dataMenu } = props;

    useEffect(() => {
        AOS.init({
            duration: 700,
        });
    }, [])

    const GoToGBU = () => {
        AxiosGet(`Authentication/RedirectToGBU`, { sPage: "Home", sLang: currentLanguage() }, (res) => {
            window.open(res, "_blank", 'noopener,noreferrer')
        })
    }

    return (
        <ContainerBG>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    // width: '80%',
                    margin: 'auto'
                }}
            >
                <SiteMap />

                <Box
                    component="footer"
                    sx={{
                        py: 2,
                        px: 2,
                        mt: 'auto',
                    }}
                    style={{ paddingTop: '1em' }}
                >
                    <Grid container direction="row" justifyContent="center" alignItems="center" >
                        <Grid item xs={10} sm={9} md={9}>
                            <Grid container spacing={2} direction="row" justifyContent="space-around" alignItems="start" style={{ paddingTop: '2em', textAlign: 'start' }}>
                                <Grid item xs={12} sm={6} md={2.5} >
                                    <Box>
                                        <img
                                            alt={"PTT Logo"}
                                            style={{ cursor: "pointer", objectFit: "contain" }}
                                            width="150px"
                                            src={LogoPTT}
                                        />
                                    </Box>
                                    <b style={{ color: "#2E86C1 ", margin: 0 }}> {currentLanguage() == "th" ? "บริษัท ปตท. จำกัด (มหาชน)" : "PTT Public Company Limited"}</b>
                                    <p></p>
                                    <p style={{ fontWeight: 300, margin: 0 }}>{currentLanguage() == "th" ? "555 ถนนวิภาวดีรังสิต แขวงจตุจักร" : "555 Vibhavadi Rangsit Road,"} </p>
                                    <p style={{ margin: 0 }}>{currentLanguage() == "th" ? "เขตจตุจักร กรุงเทพฯ 10900" : "Chatuchak Bangkok 10900 Thailand"} </p>
                                </Grid>
                                <Grid item xs={12} sm={6} md={2.5} >
                                    {
                                        dataMenu != null && dataMenu.length > 0
                                            ?
                                            <>
                                                {
                                                    dataMenu.map((item, ind) => {
                                                        return (
                                                            <NavLink
                                                                to={item.sMenuLink}
                                                                key={ind}
                                                                className={isActive => (!isActive ? " unselected" : "")}
                                                            >
                                                                <Typography style={{ fontWeight: 600, padding: '0 0 8px 0' }}>
                                                                    {currentLanguage() == "th" ? item.sMenuNameTH : item.sMenuNameENG}
                                                                </Typography>
                                                            </NavLink>
                                                        )
                                                    })
                                                }
                                            </>
                                            : null
                                    }
                                </Grid>
                                <Grid item xs={12} sm={6} md={2.5} >
                                    <a rel="noopener" onClick={() => GoToGBU()} style={{ cursor: "pointer" }}>
                                        <b>PTT GBU Web</b>
                                    </a>
                                </Grid>
                                <Grid item xs={12} sm={6} md={'auto'} >
                                    <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" >
                                        <Grid item xs={12}>
                                            <b >{currentLanguage() == "th" ? "ติดต่อสอบถาม" : "Contact"}</b>
                                            <p >02-537-3456</p>
                                        </Grid>
                                        {/* <Grid item xs={10} sm={10} md={7}>
                                            <a href="https://www.softthaiapp.com/pttgbu_uvoiceapi/apk_android_st.apk" download>
                                                <div className="btn-dowloadapp">
                                                    <Grid container direction="row" justifyContent="space-evenly" alignItems="center" >
                                                        <Grid item style={{ textAlign: 'center' }}>
                                                            <AiFillAndroid style={{ fontSize: '1.7em' }} />
                                                        </Grid>
                                                        <Grid item style={{ textAlign: 'center' }}>
                                                            <Typography style={{ fontWeight: 500, color: '#000000' }}>Download ST</Typography>
                                                            <Typography style={{ fontSize: '0.9em', color: '#000000' }}>on the android</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </a>
                                        </Grid>
                                        <Grid item xs={10} sm={10} md={7}>
                                            <a href="https://www.softthaiapp.com/pttgbu_uvoiceapi/apk_android_qa.apk" download>
                                                <div className="btn-dowloadapp">
                                                    <Grid container direction="row" justifyContent="space-evenly" alignItems="center" >
                                                        <Grid item style={{ textAlign: 'center' }}>
                                                            <AiFillAndroid style={{ fontSize: '1.7em' }} />
                                                        </Grid>
                                                        <Grid item style={{ textAlign: 'center' }}>
                                                            <Typography style={{ fontWeight: 500, color: '#000000' }}>Download QAS</Typography>
                                                            <Typography style={{ fontSize: '0.9em', color: '#000000' }}>on the android</Typography>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </a>
                                        </Grid> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Copyright />
            </Box>
        </ContainerBG>

    );
};
export default LayoutFooter;